<template>
  <div class="tasks-header">
    <TaskPartnerSelector
      class="task-partner-selector"
      :task-partners="taskPartners"
      :selected-partners="selectedPartners"
    >
      {{ getPartnerTypeLabel }}
    </TaskPartnerSelector>
    <TaskPeriodSelector
      :task-periods="taskPeriods"
      :selected-periods="selectedPeriods"
    >
      {{ getPeriodTypeLabel }}
    </TaskPeriodSelector>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TaskPartnerSelector from '../task-partner-selector';
import TaskPeriodSelector from '../task-period-selector';
import {
  TASKS_PARTNER_FILTER_EVENTS,
  TASKS_PERIOD_FILTER_EVENTS,
  tasksPartnerFilterTitles,
  tasksPeriodFilterTitles
} from '@/features/tasks';

export default {
  props: {
    taskPartners: {
      type: Array,
      required: true,
    },
    selectedPartners: {
      type: Object,
      required: false,
      default: () => {},
    },
    taskPeriods: {
      type: Array,
      required: true,
    },
    selectedPeriods: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      partnerType: null,
      periodType: null,
    };
  },
  created() {
    this.partnerType = tasksPartnerFilterTitles[1].value;
    this.periodType = tasksPeriodFilterTitles[1].value;

    this.$eventBus.$on(TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_ALL, () => this.partnerType = 'all');
    this.$eventBus.$on(TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_MAIN, () => this.partnerType = 'main');
    this.$eventBus.$onWildcard(/^tasks-filter-partner-\d+$/, () => this.partnerType = 'partner');

    this.$eventBus.$on(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_ALL, () => this.periodType = 'all');
    this.$eventBus.$on(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_TODAY, () => this.periodType = 'today');
    this.$eventBus.$on(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_TOMORROW, () => this.periodType = 'tomorrow');
    this.$eventBus.$on(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_WEEK, () => this.periodType = 'week');
    this.$eventBus.$on(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_MONTH, () => this.periodType = 'month');
  },
  beforeDestroy() {
    this.$eventBus.$off(TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_ALL, () => this.partnerType = 'all');
    this.$eventBus.$off(TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_MAIN, () => this.partnerType = 'main');
    this.$eventBus.$offWildcard(/^tasks-filter-partner-\d+$/, () => this.partnerType = 'partner');

    this.$eventBus.$off(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_ALL, () => this.periodType = 'all');
    this.$eventBus.$off(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_TODAY, () => this.periodType = 'today');
    this.$eventBus.$off(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_TOMORROW, () => this.periodType = 'tomorrow');
    this.$eventBus.$off(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_WEEK, () => this.periodType = 'week');
    this.$eventBus.$off(TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_MONTH, () => this.periodType = 'month');
  },
  components: { TaskPartnerSelector, TaskPeriodSelector },
  computed: {
    ...mapState('activeTasksModule', ['activeFilters']),
    getPartnerTypeLabel() { return tasksPartnerFilterTitles.find(item => item.value === this.partnerType)?.label; },
    getPeriodTypeLabel() { return tasksPeriodFilterTitles.find(item => item.value === this.periodType)?.label; },
  },
  watch: {
    activeFilters: {
      handler(value) {
        if (value?.partner === null) {
          this.partnerType = 'all';
        }
      },
      deep: false,
    }
  },
};
</script>

<style scoped>
.tasks-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: start;
  }
}

@media (max-width: 550px) {
  .task-partner-selector {
    margin-bottom: 16px;
  }
}
</style>
